import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { HeaderService } from 'app/services/header.service';
import { AuthService } from '../../../services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatToolbar, MatIcon, NgTemplateOutlet, NgIf, MatIconButton, MatButton, AsyncPipe],
})
export class HeaderComponent {
  private readonly destroy$: Subject<void> = new Subject<void>();

  readonly isFiltersDisabled$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  activeLink!: string;
  gridButtonText?: string;
  isDataGridOpened = false;
  showColumnsButton = false;
  hideExportButton = false;

  @Input() sideNavOpenable!: boolean;
  @Input() sideNavOpen!: boolean;

  @Input() set currentRoute(value: string) {
    this.activeLink = value;
    this.showColumnsButton = value === '/base' || value === '/analytic/operations';
    this.hideExportButton = value === '/totals';
    this.setGridButtonText();
    this.headerService.toggleDataGrid(false);
  }

  // with accordance to docs and angular source code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  leftNavigationButtonsTemplate: TemplateRef<any> | null = null;

  @Output() toggleSideNav = new EventEmitter();
  @Output() openFilterDialog = new EventEmitter();

  get isNotOfficer(): boolean {
    return !this.authService.isOfficer;
  }

  constructor(
    private readonly headerService: HeaderService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.isDataGridOpened = this.headerService.isDataGridOpened;

    this.headerService.toggleDataGridChange.subscribe((isOpened: boolean) => {
      this.isDataGridOpened = isOpened;
      this.setGridButtonText();
    });
    this.headerService.leftPanel.subscribe((x) => {
      this.leftNavigationButtonsTemplate = x;
    });

    this.checkUrlForStatusChange(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event: NavigationEnd) => {
        this.checkUrlForStatusChange(event.url);
      });
  }

  onToggleDataGrid() {
    this.headerService.toggleDataGrid(!this.isDataGridOpened);
  }

  onOpenEditColumnsPanelBtn() {
    this.headerService.toggleColumnPanel(true);
  }

  onExportClick() {
    this.headerService.export();
  }

  private setGridButtonText() {
    //TODO: get rid of this; leftNavigationButtonsTemplate should be fine for this
    this.gridButtonText = undefined;

    if (this.activeLink === '/analytic/citations') {
      this.gridButtonText = 'Top 25 Violations';
    }

    if (this.activeLink === '/analytic/vehicles') {
      this.gridButtonText = 'Vehicle Make';
    }
  }

  private checkUrlForStatusChange(url: string): void {
    url.includes('totals') ? this.toggleFilterButtonDisabling(true) : this.toggleFilterButtonDisabling(false);
  }

  private toggleFilterButtonDisabling(state: boolean): void {
    this.isFiltersDisabled$.next(state);
  }
}
